import { domReady } from "../utils";

const fnMain = () => {
  const quickDateFilterEl = document.querySelector("#quick_date_filter");
  const initialDateField = document.querySelector('[name="q[created_at_gteq]"]');
  const finalDateField = document.querySelector('[name="q[created_at_lteq]"]');

  if (!quickDateFilterEl || !initialDateField || !finalDateField) {
    return;
  }

  const init = () => {
    setupEventListeners();
  };

  const setupEventListeners = () => {
    quickDateFilterEl.addEventListener("change", handleDateFilterChange);
  };

  const handleDateFilterChange = function () {
    const filterType = this.value;
    const { startDate, endDate } = getDateRange(filterType);

    if (startDate && endDate) {
      initialDateField.value = formatDateToInput(startDate);
      finalDateField.value = formatDateToInput(endDate);
    } else {
      clearDateFields();
    }
  };

  const getDateRange = (filterType) => {
    const today = new Date();
    let startDate, endDate;

    switch (filterType) {
      case "today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case "yesterday":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(startDate);
        break;

      case "last_7_days":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 7);
        endDate = new Date(today);
        break;

      case "current_week":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay());
        endDate = new Date(today);
        break;

      case "last_30_days":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 30);
        endDate = new Date(today);
        break;

      case "current_month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      case "last_month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "last_12_months":
        startDate = new Date(today);
        startDate.setFullYear(startDate.getFullYear() - 1);
        endDate = new Date(today);
        break;

      case "current_year":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today.getFullYear(), 11, 31);
        break;

      default:
        return { startDate: null, endDate: null };
    }

    return { startDate, endDate };
  };

  const formatDateToInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const clearDateFields = () => {
    initialDateField.value = "";
    finalDateField.value = "";
  };

  init();
};

export default domReady(fnMain);